import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
	() => ({
		root: {
			width: '100%',
			height: '100%',
		},
	}),
	{ name: 'Picture' },
)

export default useStyles
